import { render, staticRenderFns } from "./StepPowerPackConfigurator.vue?vue&type=template&id=36533fea"
import script from "./StepPowerPackConfigurator.vue?vue&type=script&lang=js"
export * from "./StepPowerPackConfigurator.vue?vue&type=script&lang=js"
import style0 from "./StepPowerPackConfigurator.vue?vue&type=style&index=0&id=36533fea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports